import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {MinimumOrderValuePage} from "../minimum-order-value/minimum-order-value";
import {OpeningTimesPage} from "../opening-times/opening-times";
import {StaticPage} from "../static/static";
import { Browser } from '@capacitor/browser';
import {AnalyticsService} from "../../app/services/analytics.service";
import {Customer} from "../../app/classes/customer";
import {API} from "../../app/services/api.service";
import {COMPLETE_PAYLOAD, VERSION} from "../../app/constants/config";
import {ReportErrorPage} from "../report-error/report-error";
import { Http } from '@angular/http';


@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
  providers: [MinimumOrderValuePage, OpeningTimesPage]
})
export class SettingsPage {
  public customer: Customer;
  public VERSION: string;
  public useWhiteLogo: boolean;
  public HASH: string;

  constructor(private analytics: AnalyticsService, public http: Http, public api: API, public navCtrl: NavController, public navParams: NavParams) {
    this.customer = Customer.cachedOrCreate(this.http) as Customer;
    this.VERSION = VERSION;
    this.useWhiteLogo = COMPLETE_PAYLOAD.customer.scss_variables.indexOf("ionic.theme.dark") !== -1;
  }

  handleError(error: any) {

  }

  setCustomer(customer: Customer) {
    this.customer = customer;
  }


  showMinimumOrderValues() {
    this.analytics.trackView("Minimum Order Value");

    this.navCtrl.push(MinimumOrderValuePage);
  }

  showOpeningTimes() {
    this.analytics.trackView("Opening Times");

    this.navCtrl.push(OpeningTimesPage);
  }

  visitURL(url: string) {
    let browser = Browser.open({
      url:url
    })
  }

  showImprint() {
    this.analytics.trackView("Imprint");
    this.navCtrl.push(StaticPage, {"page": "impressum"})
  }

  showDisclaimer() {
    this.analytics.trackView("Terms of Usage");

    this.navCtrl.push(StaticPage, {"page": "haftungsausschluss"})
  }

  showLieferapps() {
    this.visitURL("https://mainorder.de");
  }

  reportError() {
    this.navCtrl.push(ReportErrorPage);
  }

  requestDelete() {
    this.visitURL("https://v1.mainorder.de/request-delete/");
  }

  showPage(page) {
    this.analytics.trackView(page.title);

    this.navCtrl.push(StaticPage, {"page": page.name})
  }

  showPrivacy() {
    this.analytics.trackView("Disclaimer");

    this.navCtrl.push(StaticPage, {"page": "datenschutzerklarung"})
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts